import JobPosting from '@root/careers/src/models/job-posting';
import PropTypes from '@root/vendor/prop-types';
import environment from '@root/core/src/utils/environment';
import useJobPostingsFromWorkday from '@root/careers/src/hooks/use-job-postings-from-workday';
import { JOB_POSTING_SOURCES } from '@root/careers/src/models/job-posting';
import { createContext } from '@root/vendor/react';

export const JobPostingContext = createContext();

export const WorkdayJobPostingProvider = ({ children, team }) => {
  const [isLoading, jobPostings] = useJobPostingsFromWorkday({ team });
  return (
    <JobPostingContext.Provider
      value={!isLoading && jobPostings}
    >
      {children}
    </JobPostingContext.Provider>
  );
};

WorkdayJobPostingProvider.propTypes = {
  children: PropTypes.node.isRequired,
  team: PropTypes.string,
};

export const LeverJobPostingProvider = ({
  children, team, data,
}) => {
  const jobPostings = data.allLever.edges.map((job) => {
    return JobPosting.createLeverJobPosting(job.node);
  }).filter((job) => !team || job.team.toLowerCase() === team.toLowerCase());

  return (
    <JobPostingContext.Provider
      value={jobPostings}
    >
      {children}
    </JobPostingContext.Provider>
  );
};

LeverJobPostingProvider.propTypes = {
  children: PropTypes.node.isRequired,
  data: PropTypes.shape({
    allLever: PropTypes.shape({
      edges: PropTypes.arrayOf(PropTypes.shape({
        node: PropTypes.object,
      })),
    }),
  }).isRequired,
  team: PropTypes.string,
};

export const getJobPostingProvider = () => {
  return environment.jobPostingSource === JOB_POSTING_SOURCES.WORKDAY ?
    WorkdayJobPostingProvider : LeverJobPostingProvider;
};
